/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `not_modelled` - Not modelled
* `basic_food` - Basic food
* `modelled_food` - Modelled food
* `external_emission_factor` - External emission factor
* `default_packaging` - Default packaging
 */
export type PurchasedGoodModelledAsEnum = typeof PurchasedGoodModelledAsEnum[keyof typeof PurchasedGoodModelledAsEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchasedGoodModelledAsEnum = {
  not_modelled: 'not_modelled',
  basic_food: 'basic_food',
  modelled_food: 'modelled_food',
  external_emission_factor: 'external_emission_factor',
  default_packaging: 'default_packaging',
} as const;
